// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__HuxZP","BreadTop":"BurgerIngredient__BreadTop__10-cT","Seeds1":"BurgerIngredient__Seeds1__3xHtz","Seeds2":"BurgerIngredient__Seeds2__1cUso","Meat":"BurgerIngredient__Meat__13nAN","Cheese":"BurgerIngredient__Cheese__1FxeY","Salad":"BurgerIngredient__Salad__1iTJE","Bacon":"BurgerIngredient__Bacon__3vrAI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 104
// module chunks = 0